// fun fact: TypeScript does not handle the key name typing and autocomplete well when this module is a JSON file
// additionally, JSON doesn't allow comments, which we need here from time to time

/**
 * There are multiple locations in the backend and database (table: RecommendedScenarios) that serve up strings that are
 * not controlled through this framework.
 *
 * Reference PRs:
 * https://github.com/gremlin/service/pull/3437
 * https://github.com/gremlin/service/pull/3445
 */
import attacks from 'i18n/en/attacks'
import authenticatedRoutes from 'i18n/en/authenticated-routes'
import clients from 'i18n/en/clients'
import common from 'i18n/en/common'
import companyEntitlements from 'i18n/en/company_entitlements'
import failureFlags from 'i18n/en/failure_flags'
import forms from 'i18n/en/forms/index'
import general from 'i18n/en/general'
import gettingStarted from 'i18n/en/getting_started'
import httpResponseStatusCodes from 'i18n/en/http_response_status_codes'
import layouts from 'i18n/en/layouts'
import navigation from 'i18n/en/navigation'
import profile from 'i18n/en/profile'
import rbacSettings from 'i18n/en/rbac_settings'
import restrictedTimeWindows from 'i18n/en/restricted_time_windows'
import scenarios from 'i18n/en/scenarios'
import service from 'i18n/en/service'
import serviceCatalog from 'i18n/en/service_catalog'
import serviceSettings from 'i18n/en/service_settings'
import statusChecks from 'i18n/en/status_checks'
import supportRisks from 'i18n/en/support_risks'
import testSuites from 'i18n/en/test_suites'

/**
 * Consolidates all EN text string files
 */
export default {
  ...attacks,
  ...authenticatedRoutes,
  ...clients,
  ...common,
  ...companyEntitlements,
  ...forms,
  ...failureFlags,
  ...gettingStarted,
  ...httpResponseStatusCodes,
  ...layouts,
  ...navigation,
  ...profile,
  ...rbacSettings,
  ...restrictedTimeWindows,
  ...scenarios,
  ...service,
  ...serviceCatalog,
  ...serviceSettings,
  ...statusChecks,
  ...supportRisks,
  ...testSuites,
  ...general
}
